import classNames from 'classnames';
import { get } from 'lodash';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import {
    ErrorItem,
    ErrorsPresenterContext,
    ErrorsPresenterContextProps
} from '../ErrorsPresenter/ErrorsPresenter';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './ErrorsView.css';

const block = 'errors-view';

export interface ErrorsViewProps {
    cls?: string;
    path: string;
}

interface ErrorsViewComponentProps extends ErrorsViewProps {
    errors: ErrorItem[];
    onErrorsViewMount: (path: string) => void;
    onErrorsViewUnmount: (path: string) => void;
    onClear?: (path: string) => void;
}

class ErrorsViewComponent extends React.PureComponent<
    ErrorsViewComponentProps
> {
    componentWillMount() {
        const { onErrorsViewMount, path } = this.props;

        onErrorsViewMount(path);
    }

    componentWillUnmount() {
        const { onErrorsViewUnmount, path } = this.props;

        onErrorsViewUnmount(path);
    }

    render() {
        const { errors, cls, onClear } = this.props;

        return errors.length ? (
            <div className={classNames(Bem.cls(block), cls)}>
                {errors.map(({ text, path }) => (
                    <div key={path} className={Bem.cls(block, 'item')}>
                        <Shape2
                            cls={Bem.cls(block, 'notice-icon')}
                            icon={Shape2Icon.warning}
                            width={16}
                            height={16}
                        />
                        <span className={Bem.cls(block, 'text')}>{text}</span>
                    </div>
                ))}

                {onClear ? (
                    <ButtonDecorator
                        cls={Bem.cls(block, 'close')}
                        size={'xs'}
                        theme={'clear'}
                        onClick={this.onClear}
                    >
                        <Shape2
                            cls={Bem.cls(block, 'close-icon')}
                            icon={Shape2Icon.cross}
                            width={12}
                            height={12}
                        />
                    </ButtonDecorator>
                ) : null}
            </div>
        ) : null;
    }

    private onClear = () => {
        const { path, onClear } = this.props;

        if (onClear) {
            onClear(path);
        }
    };
}

const EMPTY_ERRORS: ErrorItem[] = [];

export const ErrorsView = React.memo((props: ErrorsViewProps) => {
    return (
        <ErrorsPresenterContext.Consumer>
            {({
                errors,
                onErrorsViewMount,
                onErrorsViewUnmount,
                onClear
            }: ErrorsPresenterContextProps) => (
                <ErrorsViewComponent
                    key={props.path}
                    {...props}
                    errors={get(errors, props.path, EMPTY_ERRORS)}
                    onClear={onClear}
                    onErrorsViewMount={onErrorsViewMount}
                    onErrorsViewUnmount={onErrorsViewUnmount}
                />
            )}
        </ErrorsPresenterContext.Consumer>
    );
});
